import React, { FC } from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core';
import { Icons, SvgIcon } from '../../../../../shared/components';
import { preProcessLatex } from '../../../../helpers';
import ReactHtmlParser from 'react-html-parser';
import { MathJax } from 'better-react-mathjax';

type Props = {
  answer: string;
  correct: boolean;
  grey: boolean;
};

const Chip = styled(({ correct, grey, ...restProps }) => <span {...restProps} />)`
  background: ${({ grey, correct, theme }) =>
    grey
      ? theme.palette.grey['200']
      : correct
      ? theme.palette.completed.light
      : theme.palette.error.light};
  padding: ${({ grey }) => (grey ? '0.2rem 0.8rem' : '0.2rem 3rem 0.2rem 0.8rem')};
  border-radius: ${({ theme }) => theme.config.defaultBorderRadius};
  margin: 0.2rem;
  font-size: 1.4rem;
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const StyledSvgIcon = styled(SvgIcon)`
  position: absolute;
  right: 0.5rem;
`;

const StudentAnswerChip: FC<Props> = ({ answer, correct, grey }) => {
  const theme = useTheme();

  return (
    <Chip correct={correct} grey={grey}>
      <MathJax>{ReactHtmlParser(preProcessLatex(answer))}</MathJax>
      {!grey && (
        <StyledSvgIcon
          icon={correct ? Icons.ANSWER_CORRECT : Icons.ANSWER_INCORRECT}
          color={correct ? theme.palette.completed.main : theme.palette.error.main}
          small
        />
      )}
    </Chip>
  );
};

export default StudentAnswerChip;
